<span class="failedValidationSummaryTitle"
  >There is a problem with the {{ label }}</span
>
<span class="failedValidationSummarySubtitle"
  >Please correct the following:</span
>
<ul>
  @for (failedValidation of errors; track failedValidation) {
    <li>
      <a
        style="cursor: pointer"
        (click)="failedValidation.navigateToFailedField()"
        class="failedValidationSummaryDetails"
        [attr.aria-label]="failedValidation.failedValidationError"
      >
        {{ failedValidation.failedValidationError }}
      </a>
    </li>
  }
</ul>
<pre class="d-none">
      {{ failedValidations | json }}
    </pre
>
